import { queryOptions, useQuery } from '@tanstack/react-query';
import { fetchBomPlacements } from '@/api/my-styles';

export function bomPlacementsQueryOptions() {
  return queryOptions({
    queryKey: ['my-styles', 'bom', 'placements'] as const,
    queryFn: () => fetchBomPlacements({ limit: 500 }),
  });
}

export function useBomPlacements() {
  return useQuery(bomPlacementsQueryOptions());
}
